import TEXT from './generated/TEXT/suggestionsText';

TEXT.DEFINE({
  /** Title prefix for search by field (e.g., "Search by Status") */
  searchByPrefix: ({ field }: { field: string }): string =>
    `Search by ${field}`,
  /** Title for visual search (special case without "by") */
  searchVisuals: 'Search Visuals',
  /** Field name: Status */
  fieldStatus: 'Status',
  /** Field name: Comments */
  fieldComments: 'Comments',
  /** Field name: Format */
  fieldFormat: 'Format',
  /** Field name: Transcription */
  fieldTranscription: 'Transcription',
  /** Field name: Date */
  fieldDate: 'Date',
  /** Field name: Keyword */
  fieldKeyword: 'Keyword',
  /** Field name: Uploader */
  fieldUploader: 'Uploader',
  /** Field name: Resolution */
  fieldResolution: 'Resolution',
  /** Field name: Duration */
  fieldDuration: 'Duration',
  /** Field name: File Size */
  fieldFileSize: 'File Size',
  /** Field name: Assignee */
  fieldAssignee: 'Assignee',
  /** Field name: File Type */
  fieldFileType: 'File Type',
  /** Description for status search - fully translatable */
  descriptionStatusApproved: 'Show me assets that have a status of [Approved]',
  /** Description for comments search with count - fully translatable */
  descriptionCommentsCount: 'Find an image that has over [25] comments',
  /** Description for visuals search - fully translatable */
  descriptionVisualsCars: 'Find videos with [cars in the background]',
  /** Description for format search - fully translatable */
  descriptionFormat: 'Show me files in my library that are in [MP4] format',
  /** Description for transcription search - fully translatable */
  descriptionTranscriptionFlour:
    'Find videos where the transcription contains [flour]',
  /** Description for date search with days - fully translatable */
  descriptionDateDays: 'Show any video uploads from the last [30 days]',
  /** Description for keyword search - fully translatable */
  descriptionKeywordExploratory:
    'Show me videos and assets tagged with [exploratory]',
  /** Description for uploader search - fully translatable */
  descriptionUploaderJeremiah: 'Find videos and images uploaded by [Jeremiah]',
  /** Description for comments search - fully translatable */
  descriptionCommentsLighting:
    'Surface videos with comments mentioning [lighting]',
  /** Description for visuals search - fully translatable */
  descriptionVisualsMountains:
    'Pull clips featuring [mountains in the background]',
  /** Description for transcription search - fully translatable */
  descriptionTranscriptionLaunch:
    'Find videos where transcript includes [launch sequence]',
  /** Description for date search with months - fully translatable */
  descriptionDateMonths: 'List video uploads from the last [7 months]',
  /** Description for keyword search - fully translatable */
  descriptionKeywordConfidential: 'Display media tagged with [confidential]',
  /** Description for uploader search - fully translatable */
  descriptionUploaderThomas: 'List videos and images uploaded by [Thomas A]',
  /** Description for resolution search - fully translatable */
  descriptionResolution: 'List videos with resolution [1920x1080]',
  /** Description for duration search shorter - fully translatable */
  descriptionDurationShorter: 'Display videos shorter than [30 seconds]',
  /** Description for file size search larger - fully translatable */
  descriptionFileSizeLarger: 'List video and image files larger than [1GB]',
  /** Description for comments search - fully translatable */
  descriptionCommentsApproved:
    'Locate assets with comments containing [approved]',
  /** Description for visuals search - fully translatable */
  descriptionVisualsPerson: 'Show me images with [a person holding a camera]',
  /** Description for transcription search - fully translatable */
  descriptionTranscriptionBudget:
    'Find clips mentioning [budget review] in transcription',
  /** Description for date search before date - fully translatable */
  descriptionDateBefore:
    'Pull images and videos added before [January 1, 2024]',
  /** Description for keyword search - fully translatable */
  descriptionKeywordMarketing:
    "Display images, videos and PDF's tagged with [marketing]",
  /** Description for assignee search - fully translatable */
  descriptionAssignee: 'Show me videos and images assigned to [Michelle]',
  /** Description for file type search - fully translatable */
  descriptionFileType: 'Find any [MOV] files uploaded in the last week',
  /** Description for file size search smaller - fully translatable */
  descriptionFileSizeSmaller:
    "Find videos, images and PDF's smaller than [500MB]",
  /** Description for duration search longer - fully translatable */
  descriptionDurationLonger: 'Show me videos longer than [10 minutes]',
  /** Description for status search - fully translatable */
  descriptionStatusNeedsReview: 'Show me images marked [Needs Review]',
});

export const useSuggestionsText = () => {
  return {
    title: {
      status: TEXT.searchByPrefix({ field: TEXT.fieldStatus }),
      comments: TEXT.searchByPrefix({ field: TEXT.fieldComments }),
      format: TEXT.searchByPrefix({ field: TEXT.fieldFormat }),
      transcription: TEXT.searchByPrefix({ field: TEXT.fieldTranscription }),
      date: TEXT.searchByPrefix({ field: TEXT.fieldDate }),
      keyword: TEXT.searchByPrefix({ field: TEXT.fieldKeyword }),
      uploader: TEXT.searchByPrefix({ field: TEXT.fieldUploader }),
      resolution: TEXT.searchByPrefix({ field: TEXT.fieldResolution }),
      duration: TEXT.searchByPrefix({ field: TEXT.fieldDuration }),
      fileSize: TEXT.searchByPrefix({ field: TEXT.fieldFileSize }),
      assignee: TEXT.searchByPrefix({ field: TEXT.fieldAssignee }),
      fileType: TEXT.searchByPrefix({ field: TEXT.fieldFileType }),
      visuals: TEXT.searchVisuals,
    },
    description: {
      statusApproved: TEXT.descriptionStatusApproved,
      statusNeedsReview: TEXT.descriptionStatusNeedsReview,
      commentsCount: TEXT.descriptionCommentsCount,
      commentsLighting: TEXT.descriptionCommentsLighting,
      commentsApproved: TEXT.descriptionCommentsApproved,
      visualsCars: TEXT.descriptionVisualsCars,
      visualsMountains: TEXT.descriptionVisualsMountains,
      visualsPerson: TEXT.descriptionVisualsPerson,
      format: TEXT.descriptionFormat,
      transcriptionFlour: TEXT.descriptionTranscriptionFlour,
      transcriptionLaunch: TEXT.descriptionTranscriptionLaunch,
      transcriptionBudget: TEXT.descriptionTranscriptionBudget,
      dateDays: TEXT.descriptionDateDays,
      dateMonths: TEXT.descriptionDateMonths,
      dateBefore: TEXT.descriptionDateBefore,
      keywordExploratory: TEXT.descriptionKeywordExploratory,
      keywordConfidential: TEXT.descriptionKeywordConfidential,
      keywordMarketing: TEXT.descriptionKeywordMarketing,
      uploaderJeremiah: TEXT.descriptionUploaderJeremiah,
      uploaderThomas: TEXT.descriptionUploaderThomas,
      resolution: TEXT.descriptionResolution,
      durationShorter: TEXT.descriptionDurationShorter,
      durationLonger: TEXT.descriptionDurationLonger,
      fileSizeLarger: TEXT.descriptionFileSizeLarger,
      fileSizeSmaller: TEXT.descriptionFileSizeSmaller,
      assignee: TEXT.descriptionAssignee,
      fileType: TEXT.descriptionFileType,
    },
  };
};
